<template id="list-media">    
    <div>
        <!-- List cms -->
        <div class="listCmsTag">
            <div class="row">
                <div class="col-md-4">
                    <h3>Order</h3>
                </div>
                <div class="col-md-4">
                    <general-searchbox @searchButtonClick="setCurrentKeywordandSearch"></general-searchbox>
                </div>
                <div class="col-md-4">
                    <!-- <a v-bind:href="formUrl" class="btn btn-success float-right mr-3">เพิ่ม</a> -->
                </div>
            </div>            
            <general-pagination v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data" @paginateItemClick="setCurrentPageAndSearch"></general-pagination>            
            <general-loading v-if="showLoading"></general-loading>
            <div class="row">
                <div class="col-md-12">
                    <div class="card card-body mt-1" v-for="item in items" v-bind:key="'item_'+item.id">
                        <div class="row">
                            <div class="col-md-11">
                                <div class="row">
                                    <div class="col-md-4 text text-secondary">
                                        <div>
                                            <i aria-hidden="true" class="fa fa-user"></i> <span >{{item.customer.first_name}} {{item.customer.last_name}} </span> 
                                        </div>
                                        <div>
                                            <i aria-hidden="true" class="fa fa-phone"></i> <span >{{item.customer.phone_number}} </span> 
                                        </div>
                                        <div>
                                            <i aria-hidden="true" class="fa fa-at"></i> <span >{{item.customer.email_address}} </span> 
                                        </div>
                                        <div>
                                            <i aria-hidden="true" class="fa fa-money"></i> <span >{{item.payment.total}}</span> 
                                        </div>                                        
                                    </div>
                                    <div class="col-md-4 text text-secondary">                                        
                                        <div>
                                            <i aria-hidden="true" class="fa fa-ship"></i> <span >{{item.delivery.recipient_name}}</span> 
                                            <i aria-hidden="true" class="fa fa-mobile"></i> <span >{{item.delivery.recipient_phone_number}}</span> 
                                        </div>
                                        <div>
                                            <i aria-hidden="true" class="fa fa-map-marker"></i> <span >{{item.delivery.delivery_location}} {{item.delivery.delivery_address}}</span>
                                        </div>
                                        <div>
                                            <i aria-hidden="true" class="fa fa-calendar"></i> <span >{{item.delivery.delivery_date}}</span>
                                            <span >{{item.delivery.delivery_time}} </span>
                                        </div>
                                    </div>
                                    <div class="col-md-4 text text-secondary">
                                        <div class="row" v-for="product in item.products" v-bind:key="'product_'+product.id">
                                            <div class="col-md-5 m-0">
                                                {{product.product_name}}
                                            </div>
                                            <div class="col-md-4 m-0">
                                                {{parseInt(product.price_per_unit).toLocaleString()}} x {{product.quantity}}
                                            </div>
                                            <div class="col-md-3 m-0">
                                                {{parseInt(product.total_price).toLocaleString()}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group float-right">
                                    <a class="btn btn-light" v-bind:href="base_item_url+'/form/'+item.id">
                                        <i aria-hidden="true" class="fa fa-lg fa-info"></i>
                                    </a>
                                    <!-- <button type="button" class="btn btn-info" data-toggle="modal" data-target="#ConfirmDuplicateModal" @click="setForDuplicateItemId(item.id)">ทำซ้ำ</button> -->
                                    <!-- <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#ConfirmDeleteModal" @click="setForDeleteItemId(item.id)">ลบ</button> -->
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 text text-secondary">
                                สั่งเมื่อ {{item.created_at_x.ymd_his}}  ({{item.created_at_x.time_ago}})
                                <!-- , แก้ไขเมื่อ {{item.updated_at_x.time_ago}},  -->
                                <!-- <span >{{item.desc}}</span> -->
                            </div>
                            <!-- <div class="col-md-1">
                                <span class="badge badge-danger ml-1" v-if="item.disabled==1">ปิดการใช้งาน</span>
                                <span class="badge badge-success ml-1" v-if="item.disabled==0">เปิดให้ใช้งาน</span>
                            </div> -->                            
                        </div>
                    </div>
                </div>
            </div>
            <general-pagination v-if="paginate_data._infos._total && !showLoading" :paginate_data="paginate_data" @paginateItemClick="setCurrentPageAndSearch"></general-pagination>
            <div v-if="recordNotFound" class="alert alert-warning" role="alert">
                ไม่พบข้อมูล
            </div>
        </div>        
        <!-- delete modal    -->
        <!-- <general-delete-modal @ConFirmDeleteClick="performDeleteItem"></general-delete-modal> -->
        <!-- <confirmDuplicateModal @ConFirmDuplicateClick="performDuplicateItem"></confirmDuplicateModal> -->
        <!-- alert modal    -->
        <button style="display:none" type="button" class="btn btn-primary" data-toggle="modal" data-target="#AlertModal" ref="decoyAlertModalClick">test</button>
        <general-alert-modal :alertMessage="alertMessage"></general-alert-modal>
    </div>
</template>

<script>
    // import confirmDuplicateModal from './confirmDuplicateModal'
    // Vue.component('generalDuplicateModal', require('./confirmDuplicateModal.vue').default);
    export default {
        components:{
            // confirmDuplicateModal,
        },
        data() {
            return {
                items:[],
                item:{},
                item_id:'',
                paginate_data:{
                    _infos:{},
                    _base_item_list_url:''
                },
                alertMessage:{
                    titleClassName:'warning',
                    titleMessage:'แจ้งเตือน!!',
                    bodyClassName:'warning',
                    bodyMessage:'This is alert',
                },
                edit:false,
                recordNotFound:false,                
                showLoading:true,
                formUrl:'/order/form',
                base_item_url:'/order',
                currentSearchKeyword:'',
                currentPage:1,
                currentPerpage:23,
            }
        },
        mounted() {
        },
        created(){
            this.searchItems();
        },
        methods:{       
            setCurrentKeywordandSearch(searchKeyword){
                this.currentPage = 1;
                this.currentSearchKeyword = searchKeyword;
                this.searchItems();
            },
            setCurrentPageAndSearch(page){
                this.currentPage = page;
                this.searchItems();
            },
            searchItems(){      
                let url = this.base_item_url+'/list';
                url = url+'?page='+this.currentPage;
                url = url+'&perpage='+this.currentPerpage;
                url = url+'&name='+this.currentSearchKeyword;
                this.fetchItems(url);
            },
            fetchItems(url){
                this.showLoading = true;
                this.items = [];
                url = url || this.base_item_url+'/list';
                axios.get(url).then(response => {                    
                    this.items = response.data.orders;                    
                    this.paginate_data._infos = response.data._infos._paginate;               
                    this.paginate_data._infos._url_range = this.computePaginate(this.paginate_data._infos._last_page);                    
                    this.recordNotFound = this.items.length == 0 ? true : false;
                    this.showLoading = false;
                })
                .catch(errors => {
                    console.log(errors);
                })
                ;
            },
            computePaginate(lastpage){
                let result = []; let i=0;
                let data = Object.entries(this.paginate_data._infos._url_range);
                // console.log(this.paginate_data._infos._last_page);
                data.forEach(function(item){
                    if( item[0] > 0 && item[0] <= lastpage ){
                        result[i] = item;
                        i++;                       
                    }                    
                });
                // console.log(result);
                return result;
            },
            // setForDeleteItemId(item_id){
            //     // console.log(item_id);
            //     this.item_id_for_delete = item_id;
            // },

            // performDeleteItem(){
            //     // console.log(this.item_id_for_delete);
            //     axios.post(this.base_item_url+'/'+this.item_id_for_delete+'/delete').then(response => {                          
            //         // console.log(response.data._infos)
            //         this.searchItems();
            //     })
            //     .catch(errors => {                    
            //         if(errors.response.data._infos.result){                        
            //             this.alertMessage.bodyMessage = errors.response.data._infos.result;
            //             this.$refs.decoyAlertModalClick.click();
            //         }else{
            //             console.log(errors.response.data._infos.result);
            //             alert('ไม่สามารถลบได้ '+ errors.response.data);
            //         }                    
            //     })
            //     ;
            // },            
        },        
    }
</script>